<script>
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    WootMessageEditor,
    NextButton,
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      variants: [],
    };
  },
  watch: {
    variants: {
      handler(value) {
        this.$emit('update:modelValue', [...value]);
      },
      deep: true,
    },
  },
  mounted() {
    this.variants = this.modelValue?.length ? [...this.modelValue] : [''];
  },
  methods: {
    addVariant() {
      this.variants.push('');
    },
    removeVariant(index) {
      this.variants.splice(index, 1);
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <p class="mb-0 text-xs text-n-slate-11">
      {{ $t('AUTOMATION.ACTION.MESSAGE_VARIANTS.HELP_TEXT') }}
    </p>
    <ul class="flex flex-col gap-2 list-none">
      <li
        v-for="(variant, index) in variants"
        :key="index"
        class="flex items-start gap-2"
      >
        <WootMessageEditor
          v-model="variants[index]"
          rows="4"
          enable-variables
          :placeholder="
            $t('AUTOMATION.ACTION.MESSAGE_VARIANTS.VARIANT_PLACEHOLDER')
          "
          class="flex-1 [&_.ProseMirror-menubar]:hidden px-3 py-1 bg-n-alpha-1 rounded-lg outline outline-1 outline-n-weak dark:outline-n-strong"
        />
        <NextButton
          v-if="variants.length > 1"
          sm
          solid
          slate
          icon="i-lucide-trash"
          class="flex-shrink-0"
          :aria-label="$t('AUTOMATION.ACTION.MESSAGE_VARIANTS.REMOVE_VARIANT')"
          @click="removeVariant(index)"
        />
      </li>
    </ul>
    <NextButton
      sm
      ghost
      blue
      icon="i-lucide-plus"
      class="self-start"
      :label="$t('AUTOMATION.ACTION.MESSAGE_VARIANTS.ADD_VARIANT')"
      @click="addVariant"
    />
  </div>
</template>
